import { DataSource } from '@client/core/data/concerns/data-source';
import { HttpResponse } from '@client/core/http/types';

export class PropertyDataDataSource extends DataSource {
  async updatePropertyData(projectUuid: string): Promise<void> {
    await this.httpClient.post<HttpResponse<void>>(`/project/${projectUuid}/property-data`);
  }
}
